export default {
  SET_BOARD_CREATION_DETAILS(state, value) {
    state.boardCreation = value;
  },
  SET_ALL_BOARDS(state, value) {
    state.allBoards = value || [];
  },
  SET_USER_BOARD_DATA(state, value) {
    state.userBoardData = value;
  },
  SET_CURRENT_BOARD(state, value) {
    state.currentBoard = value || {};
  },
  SET_CURRENT_BOARD_USERS(state, value) {
    state.currentBoardUsers = value || [];
  },
  SET_CURRENT_BOARD_USER(state, value) {
    if (!state.currentBoardUsers) state.currentBoardUsers = [];
    state.currentBoardUsers.unshift(value);
  },
  SET_BOARD_INVITEES(state, value) {
    if (!state.currentBoardUsers) state.currentBoardUsers = [];
    state.currentBoardUsers.unshift(value);
  },
  UPDATE_BOARD_INVITEES(state, value) {
    if (!state.currentBoardUsers || !value) return;
    let index = state.currentBoardUsers.findIndex(
      (cbu) => cbu && cbu._id === value._id
    );
    if (index !== -1) {
      state.currentBoardUsers.splice(index, 1, value);
    }
  },
  DELETE_BOARD_INVITEE(state, boardUserId) {
    if (!state.currentBoardUsers) return;
    let index = state.currentBoardUsers.findIndex(
      (cbu) => cbu && cbu._id === boardUserId
    );
    if (index !== -1) {
      state.currentBoardUsers.splice(index, 1);
    }
  },
  SET_USERS_IN_BOARD(state, value) {
    state.boardUsers = value || [];
  },
  CLEAR_CURRENT_BOARD(state) {
    state.currentBoardUsers = [];
    state.currentBoard = {};
    state.boardUsers = [];
  },
  SET_USER_LEVEL_BOARDS(state, value) {
    state.userLevelBoards = value || [];
  },
  SET_CURRENT_USER_LEVEL_BOARD(state, value) {
    state.currentUserLevelBoard = value || {};
  },
  SET_CURRENT_BOARD_USER_DETAILS(state, value) {
    state.currentBoardUserDetails = value || {};
  },
  SET_FETCHING_BOARD_USERS(state, value) {
    state.fetchingBoardUsers = value;
  },
  SET_BOARD_USER_PROFILE_ANALYTICS(state, value) {
    // FIX: Ensure it defaults to an empty object instead of undefined
    state.profileCompletionMap = value || {};
  },
  SET_BOARD_USER_COACH(state, value) {
    const coachMap = {};
    if (value && Array.isArray(value)) {
      value.map((v) => {
        coachMap[v.traineeUserId] = v;
      });
    }
    state.coach = coachMap;
  },
  UPDATE_BOARD_USER_COACH(state, value) {
    if (!state.coach) state.coach = {};
    state.coach = { ...state.coach, [value.traineeUserId]: value };
  },
  SET_ALL_ARCHIVED_BOARDS(state, value) {
    state.allArchivedBoards = value || [];
  },
  SET_CURRENT_BOARD_PROGRESS(state, value) {
    state.currentUserBoardProgress = value;
  },
  SET_SEARCHED_BOARD_USERS(state, value) {
    state.searchedBoardUsers = value || [];
  }
};